import { QuoteStatus } from '@models/quotes';

export const UWHomepageTab = {
  OpenQueue: 10,
  NewBusiness: 20,
  Renewals: 30,
  Endorsements: 40,
  RecentlyViewed: 50,
};

export const NonTerminalQuoteStatuses = [
  QuoteStatus.Submission.queryParam,
  QuoteStatus.ReadyForRating.queryParam,
  QuoteStatus.Rated.queryParam,
  QuoteStatus.Referred.queryParam,
  QuoteStatus.Underwritten.queryParam,
  QuoteStatus.ReadyToBind.queryParam,
];

export const TerminalQuoteStatusesNotBound = [
  QuoteStatus.Declined.queryParam,
  QuoteStatus.Canceled.queryParam,
  QuoteStatus.Expired.queryParam,
  QuoteStatus.Rejected.queryParam,
];
